import { Input } from "@mui/material";
import styled from "styled-components";

export const StyledInput = styled(Input)`
  && {
    border: 1px solid #eaecf0;
    outline: none;
    background-color: #ffffff;
    font-family: DM Sans;
    font-size: 12px;
    font-weight: 400;
    color: #565556;
    width: 60px;
    height: 40px;
    border-radius: 5px;
    padding-left: 10px;
    &:focus {
      border: none;
      outline: none;
    }

    &::before,
    &::after {
      display: none; // Removes underline on focus and in general
    }
  }
`;

export const PxText = styled.p`
  font-size: 14px;
  color: #565556;
  font-family: DM Sans;
  font-weight: 400;
  margin: 0;
`;
